"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserUpdateDto = void 0;
const misc_1 = require("../../../misc");
const user_1 = require("../user");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const doctor_profile_1 = require("../doctor.profile");
class UserUpdateDto extends (0, misc_1.generateUpdateDto)(user_1.User, ['name', 'gender']) {
}
exports.UserUpdateDto = UserUpdateDto;
__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => doctor_profile_1.AvailabilityBlock),
    __metadata("design:type", Array)
], UserUpdateDto.prototype, "availability", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => doctor_profile_1.NotificationPreferences),
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", doctor_profile_1.NotificationPreferences)
], UserUpdateDto.prototype, "notificationPreferences", void 0);
